import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Importa os componentes do Bootstrap
import {
    Container,
    Nav,
    Navbar,
    Offcanvas,
    Form,
    Button,
    Row,
} from "react-bootstrap";

// Importa os icones
import {
    BoxArrowLeft,
    MoonStars,
    Sun,
    PersonFill,
    List,
    XLg,
} from "react-bootstrap-icons";

import IconPtBr from "../../../../Assets/Icons/br.png";
import IconEnUs from "../../../../Assets/Icons/us.png";
import IconEsEs from "../../../../Assets/Icons/es.png";

// Importa os métodos de requisição
import { deleteData } from "../../../../Services/apiService";
import { useAuth } from "../../../../Provider/Auth/AuthProvider";
import { useConfig } from "../../../../Provider/Config/config";
import { useSidebar } from "../../../../Hook/useSidebar";

// Importa o arquivo de estilos
import "./HeaderBar.css";
import UserPasswordForm from "../../../Users/Components/UserPasswordForm";
import { useTheme } from "../../../../Provider/Theme/themeContext";

export default function HeaderBar({ onShowMenu }) {
    // Hook para os alertas
    const { configs, setConfig } = useConfig();
    const { toggleTheme } = useTheme();
    //const isSmallScreen = useMediaQuery({ query: "(max-width: 768px)" });
    const { isOpen, toggleSidebar } = useSidebar();

    // Hook para o tema
    const handleTheme = () => {
        // Define o tema
        toggleTheme();
        setConfig("theme", configs.theme === "dark" ? "light" : "dark");
    };

    // Hook para a autenticação
    const { auth, logout } = useAuth();

    // Hook para a navegação
    const navigate = useNavigate();

    // Hook para a tradução
    const { t, i18n } = useTranslation();

    // Carrega os dados do usuário
    const [user, setUser] = useState({});
    useEffect(() => {
        setUser(auth.user);

        // eslint-disable-next-line
    }, []);

    // Função para o idioma
    const handleLanguage = (language) => {
        // Atualiza a configuracao do idioma
        i18n.changeLanguage(language);
        setConfig("language", language);
    };

    // Função para o logout
    const handleLogout = () => {
        // Requisição para o logout
        const apiLogout = deleteData(`/auth/logout`);
        apiLogout.then((response) => {
            if (response.status === 200) {
                logout();
                navigate("/login");
                return;
            }
        });
    };

    // Função para a troca de senha
    const [showPasswordChange, setShowPasswordChange] = useState(false);
    const handlePassword = () => {
        setShowPasswordChange(true);
    };
    const handleClosePassword = () => {
        setShowPasswordChange(false);
    };

    return (
        <>
            <Navbar expand={false} className="bg-body-tertiary header-bar p-2">
                <Container fluid>
                    <Button
                        variant="outline-secondary"
                        onClick={toggleSidebar}
                        className="header-button"
                    >
                        {isOpen ? <XLg /> : <List />}
                    </Button>
                    <Form
                        className={`ms-auto d-flex align-items-center text-align-center ${
                            configs.theme === "light"
                                ? "text-light"
                                : "text-dark"
                        }`}
                    >
                        <Form.Label className="me-2 sun-icon">
                            <Sun />
                        </Form.Label>
                        <Form.Check
                            type="switch"
                            id="custom-switch"
                            checked={
                                document.documentElement.getAttribute(
                                    "data-bs-theme"
                                ) === "dark"
                            }
                            onChange={handleTheme}
                        />
                        <Form.Label className="me-4 moon-icon">
                            <MoonStars />
                        </Form.Label>
                    </Form>
                    <Navbar.Toggle
                        aria-controls={`offcanvasNavbar-expand`}
                        className="header-user-button"
                    >
                        <PersonFill />
                    </Navbar.Toggle>
                    <Navbar.Offcanvas
                        id={`offcanvasNavbar-expand-false`}
                        aria-labelledby={`offcanvasNavbarLabel-expand`}
                        placement="end"
                        bg={configs.theme === "dark" ? "dark" : "light"}
                        data-bs-theme={
                            configs.theme === "dark" ? "dark" : "light"
                        }
                        className="offcanvas-navbar"
                    >
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title id={`offcanvasNavbarLabel-expand`}>
                                {user.name}
                            </Offcanvas.Title>
                        </Offcanvas.Header>

                        <Offcanvas.Body>
                            <Nav className="justify-content-end flex-grow-1">
                                <Row
                                    className="lang-menu"
                                    style={{ "--bs-gutter-x": "0" }}
                                >
                                    <button
                                        onClick={() => handleLanguage("pt-BR")}
                                    >
                                        <img
                                            src={IconPtBr}
                                            alt="Portuguese"
                                            className="me-2"
                                        />
                                    </button>
                                    <button
                                        onClick={() => handleLanguage("en")}
                                    >
                                        <img
                                            src={IconEnUs}
                                            alt="English"
                                            className="me-2"
                                        />
                                    </button>
                                    <button
                                        onClick={() => handleLanguage("es")}
                                    >
                                        <img src={IconEsEs} alt="Spanish" />
                                    </button>
                                </Row>
                                <Nav.Link
                                    className="user-menu mt-3"
                                    onClick={handlePassword}
                                >
                                    {t("user.password")}
                                </Nav.Link>
                                <Button
                                    onClick={handleLogout}
                                    className="btn-logout"
                                >
                                    <BoxArrowLeft />
                                    {t("user.logout")}
                                </Button>
                            </Nav>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                </Container>
            </Navbar>
            <UserPasswordForm
                user={user}
                show={showPasswordChange}
                handleClose={handleClosePassword}
            />
        </>
    );
}
